import React, { useEffect, useState } from 'react';
import "./RecordItem.scss"
import { calculateRecordTopPosition, calculateRecordHeight } from '../../../helpers/record';
import { currentTime } from '../../../helpers/datetime';

import { Link } from 'react-router-dom';

const RecordItem = ({ record, column }) => {
	const topPositionDefault = calculateRecordTopPosition(record.time_formated);
	const heightDefault = calculateRecordHeight(record.time_formated, record.time_end_formated);
	const [expirationZoneDefault, setExpirationZoneDefault] = useState(calculateRecordTopPosition(currentTime()) - topPositionDefault);

	const [topPosition, setTopPosition] = useState(topPositionDefault);
	const [height, setHeight] = useState(heightDefault);
	const [expirationZone, setExpirationZone] = useState(expirationZoneDefault);

	useEffect(() => {
		setInterval(() => {
			setExpirationZoneDefault(calculateRecordTopPosition(currentTime()) - topPositionDefault)
			setExpirationZone(calculateRecordTopPosition(currentTime()) - topPositionDefault)
		}, 10000);
	}, [])

	const onMouseEnter = () => {
		setTopPosition(topPositionDefault - 8);
		setHeight(heightDefault + 8)
		setExpirationZone(expirationZoneDefault + 8)
	};

	const onMouseLeave = () => {
		setTopPosition(topPositionDefault);
		setHeight(heightDefault)
		setExpirationZone(expirationZoneDefault)
	};
	return (

		<div className="record-item"
			style={{ top: topPosition + 'px', height: height + 'px' }}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}>
			<Link to={'/' + record.id + '/'}>
				<div className="record-item__inner">
					<div className="record-item__expiration-zone"
						style={{
							height: column.today ? Math.min(expirationZone, height) + 'px' : 0
						}}></div>
					<div className="record-item__holder">
						<div className="record-item__status">
							<div className="record-item__time">
								{record.time_formated}-{record.time_end_formated}
							</div>
							<div className={`record-item__label ${record.status.value === 'Не пришёл' ? 'not-come' : record.status.value === 'Подтверждена' ? 'confirmed' : record.status.value === 'Не подтверждена' ? 'unconfirmed' : record.status.value === 'Пришёл' ? 'arrived' : ''}`}>
								<span className='record-item__label-text'>{record.status.value}</span>
							</div>
						</div>
						<div className="record-item__user">
							{record.name}{record.age ? <span>, {record.age}</span> : ''}<br />
							{record.phone}
						</div>
						<div className="record-item__service">
							{record.service.short_title}
						</div>
					</div>
				</div>
			</Link>
		</div>
	);
};

export default RecordItem;
